import { useMutation, useQuery, UseMutationOptions, UseQueryOptions } from '@tanstack/react-query'
import { TUseMutationOptions, TUseQueryOptions } from 'core/query/type'
import {
  TPostInmailContractDeleteParams,
  TPostInmailContractDeleteResponse,
  postInmailContractDelete,
  TGetInmailContractListParams,
  TGetInmailContractListResponse,
  getInmailContractList,
  TPostInmailMarketmoveDeleteParams,
  TPostInmailMarketmoveDeleteResponse,
  postInmailMarketmoveDelete,
  TGetInmailMarketmoveListParams,
  TGetInmailMarketmoveListResponse,
  getInmailMarketmoveList,
  TGetInmailMessageCenterParams,
  TGetInmailMessageCenterResponse,
  getInmailMessageCenter,
  TPostInmailMessageClearParams,
  TPostInmailMessageClearResponse,
  postInmailMessageClear,
  TGetInmailMessageListParams,
  TGetInmailMessageListResponse,
  getInmailMessageList,
  TGetInmailModuleUnreadParams,
  TGetInmailModuleUnreadResponse,
  getInmailModuleUnread,
  TGetInmailNoticeConfigParams,
  TGetInmailNoticeConfigResponse,
  getInmailNoticeConfig,
  TPostInmailNotifyActivateParams,
  TPostInmailNotifyActivateResponse,
  postInmailNotifyActivate,
  TGetInmailNotifyStatusParams,
  TGetInmailNotifyStatusResponse,
  getInmailNotifyStatus,
  TPostInmailPricealertCreateParams,
  TPostInmailPricealertCreateResponse,
  postInmailPricealertCreate,
  TPostInmailPricealertDeleteParams,
  TPostInmailPricealertDeleteResponse,
  postInmailPricealertDelete,
  TGetInmailPricealertListParams,
  TGetInmailPricealertListResponse,
  getInmailPricealertList,
  TGetInmailPricealertLogDeleteParams,
  TGetInmailPricealertLogDeleteResponse,
  getInmailPricealertLogDelete,
  TGetInmailPricealertLogListParams,
  TGetInmailPricealertLogListResponse,
  getInmailPricealertLogList,
  TGetKafkaInmNotificationParams,
  TGetKafkaInmNotificationResponse,
  getKafkaInmNotification,
  TGetJpushInmNotificationParams,
  TGetJpushInmNotificationResponse,
  getJpushInmNotification,
  TPostV2InmailMessageListParams,
  TPostV2InmailMessageListResponse,
  postV2InmailMessageList,
  TPostV2InmailMessageStatusParams,
  TPostV2InmailMessageStatusResponse,
  postV2InmailMessageStatus,
  TGetV2InmailMessageUnReadCountParams,
  TGetV2InmailMessageUnReadCountResponse,
  getV2InmailMessageUnReadCount,
  TGetV2InmailMessageClassifyParams,
  TGetV2InmailMessageClassifyResponse,
  getV2InmailMessageClassify,
} from 'core/service/yapi/hk-web/InmailNotice/api'
// 站内信通知接口
// 合约预警记录删除
export const usePostInmailContractDeleteMutation = (
  mutationOptions?: TUseMutationOptions<TPostInmailContractDeleteResponse, TPostInmailContractDeleteParams>
) => {
  return useMutation({
    ...mutationOptions,
    mutationKey: ['InmailNotice', 'InmailContractDelete', 'Post'],
    mutationFn: (params?: TPostInmailContractDeleteParams) => postInmailContractDelete(params),
  })
}

// 查询合约预警记录列表
export const useGetInmailContractListQuery = (
  params?: TGetInmailContractListParams,
  options?: TUseQueryOptions<TGetInmailContractListResponse>
) => {
  return useQuery({
    ...options,
    queryKey: ['InmailNotice', 'InmailContractList', 'GET', ...Object.values(params || {})],
    queryFn: () => getInmailContractList(params),
  })
}

// 行情异动记录删除
export const usePostInmailMarketmoveDeleteMutation = (
  mutationOptions?: TUseMutationOptions<TPostInmailMarketmoveDeleteResponse, TPostInmailMarketmoveDeleteParams>
) => {
  return useMutation({
    ...mutationOptions,
    mutationKey: ['InmailNotice', 'InmailMarketmoveDelete', 'Post'],
    mutationFn: (params?: TPostInmailMarketmoveDeleteParams) => postInmailMarketmoveDelete(params),
  })
}

// 查询行情异动记录列表
export const useGetInmailMarketmoveListQuery = (
  params?: TGetInmailMarketmoveListParams,
  options?: TUseQueryOptions<TGetInmailMarketmoveListResponse>
) => {
  return useQuery({
    ...options,
    queryKey: ['InmailNotice', 'InmailMarketmoveList', 'GET', ...Object.values(params || {})],
    queryFn: () => getInmailMarketmoveList(params),
  })
}

// 我的消息_最新消息
export const useGetInmailMessageCenterQuery = (
  params?: TGetInmailMessageCenterParams,
  options?: TUseQueryOptions<TGetInmailMessageCenterResponse>
) => {
  return useQuery({
    ...options,
    queryKey: ['InmailNotice', 'InmailMessageCenter', 'GET', ...Object.values(params || {})],
    queryFn: () => getInmailMessageCenter(params),
  })
}

// 站内信通知_清除未读/删除消息
export const usePostInmailMessageClearMutation = (
  mutationOptions?: TUseMutationOptions<TPostInmailMessageClearResponse, TPostInmailMessageClearParams>
) => {
  return useMutation({
    ...mutationOptions,
    mutationKey: ['InmailNotice', 'InmailMessageClear', 'Post'],
    mutationFn: (params?: TPostInmailMessageClearParams) => postInmailMessageClear(params),
  })
}

// 我的消息_查询窗口消息列表
export const useGetInmailMessageListQuery = (
  params?: TGetInmailMessageListParams,
  options?: TUseQueryOptions<TGetInmailMessageListResponse>
) => {
  return useQuery({
    ...options,
    queryKey: ['InmailNotice', 'InmailMessageList', 'GET', ...Object.values(params || {})],
    queryFn: () => getInmailMessageList(params),
  })
}

// 获取通知模块的未读数量
export const useGetInmailModuleUnreadQuery = (
  params?: TGetInmailModuleUnreadParams,
  options?: TUseQueryOptions<TGetInmailModuleUnreadResponse>
) => {
  return useQuery({
    ...options,
    queryKey: ['InmailNotice', 'InmailModuleUnread', 'GET', ...Object.values(params || {})],
    queryFn: () => getInmailModuleUnread(params),
  })
}

// 获取站内信&价格订阅配置
export const useGetInmailNoticeConfigQuery = (
  params?: TGetInmailNoticeConfigParams,
  options?: TUseQueryOptions<TGetInmailNoticeConfigResponse>
) => {
  return useQuery({
    ...options,
    queryKey: ['InmailNotice', 'InmailNoticeConfig', 'GET', ...Object.values(params || {})],
    queryFn: () => getInmailNoticeConfig(params),
  })
}

// 设置通知推送状态
export const usePostInmailNotifyActivateMutation = (
  mutationOptions?: TUseMutationOptions<TPostInmailNotifyActivateResponse, TPostInmailNotifyActivateParams>
) => {
  return useMutation({
    ...mutationOptions,
    mutationKey: ['InmailNotice', 'InmailNotifyActivate', 'Post'],
    mutationFn: (params?: TPostInmailNotifyActivateParams) => postInmailNotifyActivate(params),
  })
}

// 获取当前用户推送设置状态
export const useGetInmailNotifyStatusQuery = (
  params?: TGetInmailNotifyStatusParams,
  options?: TUseQueryOptions<TGetInmailNotifyStatusResponse>
) => {
  return useQuery({
    ...options,
    queryKey: ['InmailNotice', 'InmailNotifyStatus', 'GET', ...Object.values(params || {})],
    queryFn: () => getInmailNotifyStatus(params),
  })
}

// 现货行情_创建价格订阅
export const usePostInmailPricealertCreateMutation = (
  mutationOptions?: TUseMutationOptions<TPostInmailPricealertCreateResponse, TPostInmailPricealertCreateParams>
) => {
  return useMutation({
    ...mutationOptions,
    mutationKey: ['InmailNotice', 'InmailPricealertCreate', 'Post'],
    mutationFn: (params?: TPostInmailPricealertCreateParams) => postInmailPricealertCreate(params),
  })
}

// 现货行情_删除价格订阅
export const usePostInmailPricealertDeleteMutation = (
  mutationOptions?: TUseMutationOptions<TPostInmailPricealertDeleteResponse, TPostInmailPricealertDeleteParams>
) => {
  return useMutation({
    ...mutationOptions,
    mutationKey: ['InmailNotice', 'InmailPricealertDelete', 'Post'],
    mutationFn: (params?: TPostInmailPricealertDeleteParams) => postInmailPricealertDelete(params),
  })
}

// 现货行情_查询价格订阅列表
export const useGetInmailPricealertListQuery = (
  params?: TGetInmailPricealertListParams,
  options?: TUseQueryOptions<TGetInmailPricealertListResponse>
) => {
  return useQuery({
    ...options,
    queryKey: ['InmailNotice', 'InmailPricealertList', 'GET', ...Object.values(params || {})],
    queryFn: () => getInmailPricealertList(params),
  })
}

// 现货行情_价格订阅提醒删除
export const useGetInmailPricealertLogDeleteQuery = (
  params?: TGetInmailPricealertLogDeleteParams,
  options?: TUseQueryOptions<TGetInmailPricealertLogDeleteResponse>
) => {
  return useQuery({
    ...options,
    queryKey: ['InmailNotice', 'InmailPricealertLogDelete', 'GET', ...Object.values(params || {})],
    queryFn: () => getInmailPricealertLogDelete(params),
  })
}

// 现货行情_查询价格订阅提醒列表
export const useGetInmailPricealertLogListQuery = (
  params?: TGetInmailPricealertLogListParams,
  options?: TUseQueryOptions<TGetInmailPricealertLogListResponse>
) => {
  return useQuery({
    ...options,
    queryKey: ['InmailNotice', 'InmailPricealertLogList', 'GET', ...Object.values(params || {})],
    queryFn: () => getInmailPricealertLogList(params),
  })
}

// kafka站内信通知
export const useGetKafkaInmNotificationQuery = (
  params?: TGetKafkaInmNotificationParams,
  options?: TUseQueryOptions<TGetKafkaInmNotificationResponse>
) => {
  return useQuery({
    ...options,
    queryKey: ['InmailNotice', 'KafkaInmNotification', 'GET', ...Object.values(params || {})],
    queryFn: () => getKafkaInmNotification(params),
  })
}

// 极光通知推送说明
export const useGetJpushInmNotificationQuery = (
  params?: TGetJpushInmNotificationParams,
  options?: TUseQueryOptions<TGetJpushInmNotificationResponse>
) => {
  return useQuery({
    ...options,
    queryKey: ['InmailNotice', 'JpushInmNotification', 'GET', ...Object.values(params || {})],
    queryFn: () => getJpushInmNotification(params),
  })
}

// 消息列表
export const usePostV2InmailMessageListMutation = (
  mutationOptions?: TUseMutationOptions<TPostV2InmailMessageListResponse, TPostV2InmailMessageListParams>
) => {
  return useMutation({
    ...mutationOptions,
    mutationKey: ['InmailNotice', 'V2InmailMessageList', 'Post'],
    mutationFn: (params?: TPostV2InmailMessageListParams) => postV2InmailMessageList(params),
  })
}

// 消息未读状态
export const usePostV2InmailMessageStatusMutation = (
  mutationOptions?: TUseMutationOptions<TPostV2InmailMessageStatusResponse, TPostV2InmailMessageStatusParams>
) => {
  return useMutation({
    ...mutationOptions,
    mutationKey: ['InmailNotice', 'V2InmailMessageStatus', 'Post'],
    mutationFn: (params?: TPostV2InmailMessageStatusParams) => postV2InmailMessageStatus(params),
  })
}

// 消息未读数量
export const useGetV2InmailMessageUnReadCountQuery = (
  params?: TGetV2InmailMessageUnReadCountParams,
  options?: TUseQueryOptions<TGetV2InmailMessageUnReadCountResponse>
) => {
  return useQuery({
    ...options,
    queryKey: ['InmailNotice', 'V2InmailMessageUnReadCount', 'GET', ...Object.values(params || {})],
    queryFn: () => getV2InmailMessageUnReadCount(params),
  })
}

// 获取消息分类
export const useGetV2InmailMessageClassifyQuery = (
  params?: TGetV2InmailMessageClassifyParams,
  options?: TUseQueryOptions<TGetV2InmailMessageClassifyResponse>
) => {
  return useQuery({
    ...options,
    queryKey: ['InmailNotice', 'V2InmailMessageClassify', 'GET', ...Object.values(params || {})],
    queryFn: () => getV2InmailMessageClassify(params),
  })
}
